// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__glooC","requiredAsterisk":"Info_requiredAsterisk__1JyGg"};